import { useSyles } from './styles';

const ButtonBarcode = ({ src, onClick, ...props }: any) => {
  const classes = useSyles();
  return (
    <div className={classes.container} onClick={onClick} {...props}>
      <img width='auto' src={src} alt='' />
    </div>
  );
};

export default ButtonBarcode;
